import React from "react";
import PageTemplateA from "../templates/templateA"
import { shallowEqual, useSelector } from "react-redux";
import { ContainerWrapper } from "../styleds";
import LimitDetails from "../components/errors/LimitDetails";

export const TransactionErrorPage = () => {
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { bankName, transactionType, transactionAmount, transactionLimit, accountNumberMask, merchantName, merchantReturnUrl, error_code, displayDetailsLimit } = appStore;

  const generateError602 = () => {
    let suggestionText;
    if (!isNaN(transactionLimit) && transactionLimit > 0) {
      suggestionText = `Retry the ${transactionType} with up to $${transactionLimit} or try again with another bank account.`;
    } else {
      suggestionText = "Go back to the merchant and try again with another bank account.";
    }

    return {
      icon: "speechIcon",
      title: "Sorry, transaction limit exceeded",
      description: <LimitDetails
        transactionType={transactionType}
        transactionAmount={transactionAmount}
        transactionLimit={transactionLimit}
        bankName={bankName}
        accountNumberMask={accountNumberMask}
        displayDetailsLimit={displayDetailsLimit}
      />,
      suggestion: suggestionText,
      footerNote: null,
      mainAction: { text: `Back to ${merchantName}`, href: merchantReturnUrl },
      secondaryAction: null,
    };
  };

  const generateFallbackError = () => {
    let descriptionText = null;
    if (bankName && accountNumberMask) {
      descriptionText = `Selected account: ${bankName} ••••••${accountNumberMask}. No money was exchanged.`;
    }
    return {
      icon: "speechIcon",
      title: "Sorry, the transaction could not be completed",
      description: descriptionText,
      suggestion: "Go back to the merchant and try again with another bank account.",
      footerNote: null,
      mainAction: { text: `Back to ${merchantName}`, href: merchantReturnUrl },
      secondaryAction: null,
    }
  };

  const errorTemplates = {
    602: generateError602(),
    611: generateError602(),
    86: {
      icon: "speechIcon",
      title: "Sorry, the transaction could not be completed",
      description: "No money was exchanged.",
      suggestion: "You may be able to complete the transaction with another bank account.",
      footerNote: null,
      mainAction: { text: `Back to ${merchantName}`, href: merchantReturnUrl },
      secondaryAction: null,
    },
    83: {
      icon: "speechIcon",
      title: "Sorry, your identity verification failed",
      description: "Some of your information is not valid. No money was exchanged.",
      suggestion: `Make sure your account profile is correct on ${merchantName} or try again with another bank account.`,
      footerNote: null,
      mainAction: { text: `Back to ${merchantName}`, href: merchantReturnUrl },
      secondaryAction: null,
    },
    89: {
      icon: "speechIcon",
      title: "Sorry, there are not enough funds at the moment to complete the deposit",
      description: `Selected account: ${bankName} ••••••${accountNumberMask}. No money was exchanged.`,
      suggestion: "Go back to the merchant and try again with another bank account.",
      footerNote: null,
      mainAction: { text: `Back to ${merchantName}`, href: merchantReturnUrl },
      secondaryAction: null,
    },
    default: generateFallbackError(),
  };

  const errorKey = errorTemplates[error_code] === undefined ? "default" : error_code;
  const errorTemplate = errorTemplates[errorKey];
  const showDescription = ( errorKey === "default" && accountNumberMask !== undefined) ||
    (errorKey !== "default" && bankName && accountNumberMask) ||
    (errorKey === 83)
  ;
  const showFooter = false;
  return (
    <ContainerWrapper footer={showFooter}>
      <PageTemplateA
        icon={errorTemplate.icon}
        title={errorTemplate.title}
        description={showDescription ? errorTemplate.description : ""}
        suggestion={errorTemplate.suggestion}
        footerNote={errorTemplate.footerNote}
        mainAction={errorTemplate.mainAction}
        secondaryAction={errorTemplate.secondaryAction}
        showFooter={showFooter}
        showCloseButton={false}
      />
    </ContainerWrapper>
  );
};

TransactionErrorPage.propTypes = {};

TransactionErrorPage.defaultProps = {};

export default TransactionErrorPage;
